import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  url: null,
  message: null,
  wait: 0,
}

const redirectionSlice = createSlice({
  name: 'redirection',
  initialState,
  reducers: {
    redirectTo(state, action) {
      const { url, message, wait } = action.payload
      if (!url) {
        console.warn('redirectTo action requires an object as payload with a url key')
      } else {
        state.url = url
        state.message = message || null
        state.wait = 0 || wait
      }
    },
  },
})

const selectBase = state => state.redirection
const selectRedirection = state => {
  const data = selectBase(state)
  return {
    url: data.url,
    message: data.message,
    wait: data.wait,
  }
}

export const actions = {
  ...redirectionSlice.actions,
}

export const selectors = {
  selectRedirection,
}

export default redirectionSlice.reducer
